import { useEffect, useState } from "react"
import { SITE } from "@/data/site"

const NAV = [
  { href: "#about", label: "關於" },
  { href: "#fragrance", label: "限定珍藏香氛" },
  { href: "#order", label: "立即訂購" },
  { href: "#faq", label: "常見問題" },
]

function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-700 ${
        scrolled || open ? "bg-[#080808]/95" : "bg-transparent"
      }`}
    >
      <div className="flex w-full items-center justify-between px-8 py-4 md:px-10 lg:px-16">
        <a href="#top" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <span className="flex items-center">
            <img src={SITE.logo} alt="MR. EAR" className="h-8 w-auto object-contain mix-blend-screen md:h-11" />
          </span>
          <span className="font-sans-ui text-xs tracking-[0.28em] text-stone-200">{SITE.brand}</span>
        </a>
        <nav className="hidden items-center gap-10 md:flex">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="font-sans-ui text-[11px] tracking-[0.32em] text-stone-300 transition-colors duration-500 hover:text-[#c4a574]"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center md:hidden"
          aria-label={open ? "關閉選單" : "開啟選單"}
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className="relative block h-3 w-5">
            <span
              className={`absolute left-0 h-px w-5 bg-stone-200 transition-all duration-500 ${
                open ? "top-1.5 rotate-45" : "top-0"
              }`}
            />
            <span
              className={`absolute left-0 top-1.5 h-px w-5 bg-stone-200 transition-opacity duration-500 ${
                open ? "opacity-0" : "opacity-100"
              }`}
            />
            <span
              className={`absolute left-0 h-px w-5 bg-stone-200 transition-all duration-500 ${
                open ? "top-1.5 -rotate-45" : "top-3"
              }`}
            />
          </span>
        </button>
      </div>
      {open ? (
        <nav className="flex flex-col gap-6 border-t border-white/10 bg-[#080808] px-8 py-8 md:hidden">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="font-sans-ui text-sm tracking-[0.32em] text-stone-300"
              onClick={() => setOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </nav>
      ) : null}
    </header>
  )
}

export default Header
